import { isNumber, isString } from 'utils/tsHelpers';
import { HandlebarNumber } from './HandlebarNumber';

export class HandlebarInt extends HandlebarNumber {
  toString() {
    // Ensure int renders without a decimal point or decimal
    return this.value.toFixed(0);
  }

  static parse(from: unknown): HandlebarInt {
    if (isNumber(from)) {
      return new HandlebarInt(Math.floor(from));
    } else if (isString(from)) {
      return new HandlebarInt(Math.floor(parseInt(from, 10)));
    }
    return new HandlebarInt(NaN);
  }
}
